// extracted by mini-css-extract-plugin
export default {"root":"V8XadeeB","item":"xOmgBNMm"};